import React, { useContext } from 'react';
import { AppContext } from '../app/AppProvider.component';
import { getIsAIChatSidebarEnabled } from '../app/app-state-selectors.utilities';
import {
  trackAdobeAction,
  trackNewRelicAction
} from '../app/app-state-actions.utilities';
import IconWithText from '../icon-with-text/IconWithText.component';
import { RemediationAssignmentWithSourcesDto } from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import {
  AdobeAnalyticsAction,
  AdobeAnalyticsButtonType
} from '../../models/adobe-analytics.models';
import { NewRelicAnalyticsAction } from '../../models/new-relic-analytics.models';
import { PageContextType } from '../../utilities/sherpath-ai-context.utilities';
import { getProduct, getProductConfig } from '../../utilities/product.utilities';

export type SherpathAIChatToggleProps = {
  remediationAssignmentWithSources: RemediationAssignmentWithSourcesDto;
  pageContextType: PageContextType;
};

export const SherpathAIChatToggle = (props: SherpathAIChatToggleProps): JSX.Element => {
  const {
    appState,
    appStateRef,
    setAppState
  } = useContext(AppContext);

  const { remediationAssignmentWithSources, pageContextType } = props;

  const isAIChatSidebarEnabled = getIsAIChatSidebarEnabled(appState, remediationAssignmentWithSources);
  const { aiChatName } = getProductConfig(getProduct(remediationAssignmentWithSources));

  const handleChatToggle = () => {
    const isOpening = !appState.isChatActive;
    const remediationAssignmentId = remediationAssignmentWithSources?.remediationAssignment?.id;

    trackAdobeAction({
      appStateRef,
      actionProps: {
        action: AdobeAnalyticsAction.BUTTON_CLICK,
        pageData: {
          buttonType: `${pageContextType}:${AdobeAnalyticsButtonType.BUTTON}:${isOpening ? 'sherpathAiOpen' : 'sherpathAiClose'}`,
        }
      }
    });

    trackNewRelicAction({
      appStateRef,
      actionProps: {
        action: NewRelicAnalyticsAction.SHERPATH_AI_TOGGLED,
        props: {
          targetState: isOpening ? 'opened' : 'closed',
          pageContextType,
          remediationAssignmentId
        }
      }
    });

    setAppState({
      ...appState,
      isChatActive: isOpening
    });
  };

  // Don't render if chat is not enabled
  if (!isAIChatSidebarEnabled) {
    return null;
  }

  // Button variant - secondary when closed, tertiary when open
  const buttonClass = appState.isChatActive
    ? "c-els-button c-els-button--small c-els-button--tertiary"
    : "c-els-button c-els-button--small c-els-button--secondary";

  return (
    <button
      className={buttonClass}
      type="button"
      onClick={handleChatToggle}
    >
      <IconWithText
        iconName="comment"
        iconPrefix="gizmo"
        iconSize="1x1o2"
      >
        Ask {aiChatName}
      </IconWithText>
    </button>
  );
};
